import { TrueToSizeBlockUI } from "./TrueToSizeBlockUI";
import { StandardProps } from "../componentMap";

export function TrueToSizeBlock({
  product,
  runtimeConfig,
  flags,
}: Pick<StandardProps, "product" | "runtimeConfig" | "flags">) {
  const { reviewsApiKey, reviewsSubratingUrl } = runtimeConfig;
  const useNewTypography = flags.useNewTypography.value === true;

  return (
    <TrueToSizeBlockUI
      productId={product.aliases.pimProductId}
      reviewsApiKey={reviewsApiKey}
      reviewsSubratingScriptUrl={reviewsSubratingUrl}
      useNewTypography={useNewTypography}
    />
  );
}
